<template>
  <Modal id="UserFeeDetail" width="50%" :open="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('userFee.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('userFee.field.id_use_fee')">{{data.idUseFee}}</DescriptionsItem>
      <DescriptionsItem :label="$t('userFee.field.id_cha_poi')">{{data.chargeBoxId}}</DescriptionsItem>
      <DescriptionsItem :label="$t('userFee.field.id_spa')">{{data.nameZh}}</DescriptionsItem>
      <DescriptionsItem :label="$t('userFee.field.id_use')">{{data.account}}</DescriptionsItem>
      <DescriptionsItem :label="$t('userFee.field.fee_amount')">{{data.feeAmount}}</DescriptionsItem>
      <DescriptionsItem :label="$t('userFee.field.start_month')">{{data.startMonth}}</DescriptionsItem>
      
  </Descriptions>
  </Modal>
</template>
<script>
export default {
  name: "UserFeeDetail",
}
</script>
<script setup>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import {reactive, ref, toRefs} from "vue";
import {useI18n} from "vue-i18n";

const i18n = useI18n()

let visible = ref(false)

const dataTemp = reactive({
  data: {}
})
const {data} = toRefs(dataTemp)

async function detailShow(obj) {
  data.value = JSON.parse(JSON.stringify(obj));
  visible.value = true;
}

defineExpose({
  detailShow
})
</script>